import { render, staticRenderFns } from "./FollowedRequests.vue?vue&type=template&id=44599139&"
import script from "./FollowedRequests.vue?vue&type=script&lang=js&"
export * from "./FollowedRequests.vue?vue&type=script&lang=js&"
import style0 from "./FollowedRequests.vue?vue&type=style&index=0&id=44599139&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports